// extracted by mini-css-extract-plugin
module.exports = {"legitScriptsCertified":"legitScriptsCeritified_legitScriptsCertified__NvqK8","text":"legitScriptsCeritified_text__Dj5vI"};